import React, { useState, useEffect } from 'react';

const ScrollContainer = ({ children }) => {
  const [isScrolling, setIsScrolling] = useState(false);
  let scrollTimer = null;

  useEffect(() => {
    // Cleanup the timer on unmount
    return () => {
      if (scrollTimer) clearTimeout(scrollTimer);
    };
  }, []);

  const handleScroll = (e) => {
    // Show scrollbar
    setIsScrolling(true);

    // Clear any existing timer
    if (scrollTimer) clearTimeout(scrollTimer);

    // Set new timer to hide scrollbar
    scrollTimer = setTimeout(() => {
      setIsScrolling(false);
    }, 1000); // Hide after 1 second of no scrolling
  };

  return (
    <div 
      onScroll={handleScroll}
      style={{
        position: 'relative',
        overflow: 'auto',
        height: '100%',
      }}
      className={`custom-scrollbar ${isScrolling ? 'scrolling' : ''}`}
    >
      {children}
      <style>
        {`
          .custom-scrollbar {
            scrollbar-width: thin; /* For Firefox */
            scrollbar-color: transparent transparent; /* For Firefox */
            transition: scrollbar-color 0.3s ease;
          }

          .custom-scrollbar::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }

          .custom-scrollbar::-webkit-scrollbar-track {
            background: transparent;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: transparent;
            border-radius: 20px;
            border: 2px solid transparent;
            transition: background-color 0.3s ease;
          }

          .custom-scrollbar.scrolling {
            scrollbar-color: rgba(155, 155, 155, 0.7) transparent; /* For Firefox */
          }

          .custom-scrollbar.scrolling::-webkit-scrollbar-thumb {
            background-color: rgba(155, 155, 155, 0.7);
          }

          /* For horizontal scrollbar */
          .custom-scrollbar.horizontal {
            overflow-x: auto;
            overflow-y: hidden;
          }

          /* Hover state for better UX */
          .custom-scrollbar:hover::-webkit-scrollbar-thumb {
            background-color: rgba(155, 155, 155, 0.3);
          }

          .custom-scrollbar.scrolling:hover::-webkit-scrollbar-thumb {
            background-color: rgba(155, 155, 155, 0.8);
          }
        `}
      </style>
    </div>
  );
};

export default ScrollContainer;
